import { VITE_ENV } from '../constants/envs';
import { tSentryConfig } from './sentry.types';

// Sentry environment variables
export const VITE_SENTRY_ENABLED = import.meta.env.VITE_SENTRY_ENABLED;
export const VITE_SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const VITE_SENTRY_TRACES_SAMPLE_RATE = import.meta.env
  .VITE_SENTRY_TRACES_SAMPLE_RATE;
export const VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE = import.meta.env
  .VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE;
export const VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE = import.meta.env
  .VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE;

// Tunnel routes Sentry events through the nginx-api-gateway (/resources/sentry)
// so the CSP connect-src only needs *.leadsales.services instead of *.sentry.io.
const API_GATEWAY_BASE = (import.meta.env.VITE_BASE_URL_LEGACY ?? '').replace(/\/$/, '').replace(/\/v2\/web.*$/, '') as string;
const SENTRY_TUNNEL_URL = `${API_GATEWAY_BASE}/resources/sentry`;

// Sentry configuration
export const sentryConfig: tSentryConfig = {
  enabled: VITE_SENTRY_ENABLED,
  dsn: VITE_SENTRY_DSN,
  environment: VITE_ENV,
  tunnel: SENTRY_TUNNEL_URL,
  tracesSampleRate: VITE_SENTRY_TRACES_SAMPLE_RATE,
  replaysSessionSampleRate: VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
  replaysOnErrorSampleRate: VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
};
